import { faRss } from "@fortawesome/pro-regular-svg-icons/faRss";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconFollow: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faRss} />;
};
